<template>
  <div class="text-xs-center">
    <v-progress-circular
      color="primary"
      indeterminate
    />
  </div>
</template>

<script>
import Vue from 'vue'

const spinner = {
  name:'spinner',
}
Vue.component('spinner', spinner)
export default spinner

</script>

<style scoped>

</style>
